export default __webpack_public_path__ + "static/media/seiseki4.a74ef9a2.png";